import { render, staticRenderFns } from "./contact-form-page.vue?vue&type=template&id=694200d2&"
import script from "./contact-form-page.vue?vue&type=script&lang=js&"
export * from "./contact-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports